import { __extends } from "tslib";
import { SdkMessageTypes } from '../constants';
import { BaseMessageHandler } from './base-message-handler';
import { formulateSdkResponse, onSdkError } from './messageHandlingUtils';
/**
 * Responsible for handling profile based calls like showProfile.
 */
var ProfileMessageHandler = /** @class */ (function (_super) {
    __extends(ProfileMessageHandler, _super);
    function ProfileMessageHandler(appSdkHost, profileService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.appSdkHost = appSdkHost;
        _this.profileService = profileService;
        return _this;
    }
    ProfileMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.profile.showProfile, function (_, request) {
            // The targetRectangle is relative to the iframe top left, so we
            // need to offset by the iframe top left to get the right position.
            var frame = _this.appSdkHost.getFrame();
            var _a = frame ? frame.getBoundingClientRect() : { x: 0, y: 0 }, xOffset = _a.x, yOffset = _a.y;
            var windowRelativeBoundingRect = DOMRect.fromRect({
                x: request.targetRectangle.x + xOffset,
                y: request.targetRectangle.y + yOffset,
                width: request.targetRectangle.width,
                height: request.targetRectangle.height,
            });
            var showProfileRequest = {
                modality: request.modality,
                persona: request.persona,
                targetElementBoundingRect: windowRelativeBoundingRect,
                triggerType: request.triggerType,
            };
            return formulateSdkResponse(showProfileRequest, _this.profileService.showProfile);
        }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.profile.showProfile, error, scenario); },
        });
    };
    ProfileMessageHandler.prototype.validateDependencies = function () {
        if (!this.profileService) {
            throw 'No profileService provided';
        }
    };
    return ProfileMessageHandler;
}(BaseMessageHandler));
export { ProfileMessageHandler };
//# sourceMappingURL=profile-message-handler.js.map